import SurveyMain from './components/SurveyMain'

export default SurveyMain
